import noticeSidebar from "@components/noticeSidebar/m2_noticeSidebar";
export default {
    components: {
        noticeSidebar
    },
    data: function () {
        return {
            user: {},
            testInforms: [],
            tipNoticeList: [],
            tipNoticeNum: 0,
            dialogVisible: false,
            tipDialogVisible: false,
            one_notice: {
                content: "",
                title: "",
                proc_id: ""
            },
            haveTip: false,
            this_notice: {
                content: "",
                title: "",
                proc_id: ""
            },
            pageIndex: 1,
            pageSize: 10,
            pageSizes: [5, 10, 20, 50],
            total: 0,
            logoUrl: "",
            examName: "",
            domain: "",
            font_range: "",
            font_type: "",
            url_name: ""
        };
    },
    created: function () {
        this.getData();
        this.$store.commit("setHeaderState", "23");
    },
    methods: {
        pageIndexChange: function (pageIndex) {
            this.pageIndex = pageIndex;
            this.getData();
        },
        sizeChange: function (pageSize) {
            this.pageSize = pageSize;
            if (this.pageIndex === 1) {
                this.getData();
            } else {
                this.pageIndex = 1;
                this.getData();
            }
        },
        getNormalAnn: function (captcha_token) {
            let url;
            if( this.$store.state.examInfo.currentExamInfo.batchCode){
                url = 'ea/g/nts/l/{domain}/{page_index}/{page_size}/{n_type}/BATCH/'+this.$store.state.examInfo.currentExamInfo.batchCode;
            }else{
                url = 'ea/g/nts/l/{domain}/{page_index}/{page_size}/{n_type}/PROJECT';
            }
            this.$http
                .get(
                    globalProvider.serviceUrl(
                        url
                    ), {
                        params: {
                            domain: this.$store.state.examInfo.currentExamInfo.domain,
                            page_index: this.pageIndex,
                            page_size: this.pageSize,
                            n_type: "se"
                        },
                        headers: {
                            ttoken: captcha_token
                        },
                        emulateJSON: false
                    }
                )
                .then(data => {
                    if (data.body.code == resultCode.Success) {
                        data.body.data.map(item => {
                            if (item.type == 2) {
                                this.testInforms = item._items;
                                this.total = item.totalCount;
                                this.pageIndex = item.pageIndex;
                            }
                        });
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(getErrorMessage(data.body.message), "提示", {
                            confirmButtonText: "确定"
                        });
                    }
                });
        },
        getProblemSolving: function (notice_id, id) {
            document.getElementsByClassName("notice-dialog-body").scrollTop = 0;
            this.dialogVisible = true;
            this.$http
                .get(globalProvider.serviceUrl("ea/g/nts/d/{notice_id}"), {
                    params: {
                        notice_id: notice_id
                    }
                })
                .then(data => {
                    if (data.body.code == resultCode.Success) {
                        this.one_notice = data.body.data;
                    } else if (data.body.code == resultCode.NotSuccess) {
                        this.$alert(getErrorMessage(data.body.message), "提示", {
                            confirmButtonText: "确定"
                        });
                    }
                });

        },
        getData() {
            this.getNormalAnn();
        }
    }
};